import { Props_SnippetImageContent } from './ImageContent.props'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'

const SnippetImageContent = (props: Props_SnippetImageContent) => {
    const { snippet, heading, image, content } = props

    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-image-content__heading--${heading.visibility.value}` : ''
    const classSnippetLayout = `snippet-image-content--${snippet.layout?.value}`
    const classSnippetTheme = `snippet-image-content--theme-${snippet.theme?.value}`
    const classImageCrop = image.crop?.value ? `snippet-image-content__image--crop-${image.crop.value}` : ''
    const classImageShadow = image.imageShadow?.value === 'true' ? 'snippet-image-content__container-image--shadow' : ''

    return (
        <section className={`snippet-image-content ${classSnippetLayout} ${classSnippetTheme}`}>
            <div className="snippet-image-content__container">
                <figure className={`snippet-image-content__container-image ${classImageShadow}`}>
                    <img
                        loading="lazy"
                        src={image.src?.value}
                        className={`snippet-image-content__image ${classImageCrop}`}
                        height="400"
                        width="600"
                        alt={image.alt?.value ? image.alt.value : ''}
                    />
                </figure>
                <div className="snippet-image-content__container-content">
                    <h2 className={`snippet-image-content__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                    { content.content?.value && (
                        <div className="snippet-image-content__content">
                            { Legacy_CompileMarkdown(content.content.value) }
                        </div>
                    )}
                    { content.linkUrl?.value && content.linkContent?.value && content.linkTarget?.value && (
                        <a
                            className="snippet-image-content__link"
                            href={content.linkUrl.value}
                            target={content.linkTarget?.value === 'true' ? '_blank' : '_self'}
                            rel={content.linkTarget?.value === 'true' ? 'noopener noreferrer' : undefined}
                        >
                            {content.linkContent?.value}
                        </a>
                    )}
                </div>
            </div>
        </section>
    )
}

export default SnippetImageContent